/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSON,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSONTyped,
    JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationToJSON,
} from './JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse {
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
     */
    cafeMenuInfo?: Array<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo>;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
     */
    cafeReservation?: JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
     */
    benepoUseFlag?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
     */
    benepoAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse
     */
    billingAmount?: number;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cafeMenuInfo': !exists(json, 'cafeMenuInfo') ? undefined : ((json['cafeMenuInfo'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSON)),
        'cafeReservation': !exists(json, 'cafeReservation') ? undefined : JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSON(json['cafeReservation']),
        'benepoUseFlag': !exists(json, 'benepoUseFlag') ? undefined : json['benepoUseFlag'],
        'benepoAmountTotal': !exists(json, 'benepoAmountTotal') ? undefined : json['benepoAmountTotal'],
        'billingAmount': !exists(json, 'billingAmount') ? undefined : json['billingAmount'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cafeMenuInfo': value.cafeMenuInfo === undefined ? undefined : ((value.cafeMenuInfo as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoToJSON)),
        'cafeReservation': JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationToJSON(value.cafeReservation),
        'benepoUseFlag': value.benepoUseFlag,
        'benepoAmountTotal': value.benepoAmountTotal,
        'billingAmount': value.billingAmount,
    };
}

